
/* injects from baggage-loader */

import loadTypes from 'utils/loadTypes'

export const MERCHANT = loadTypes('MERCHANT')
export const MERCHANT_CREATE = loadTypes('MERCHANT_CREATE')

function merchantReducer(merchants) {
  return merchants.reduce((acc, merchant) => ({
    ...acc,
    [merchant.id]: {
      ...merchant,
      timePeriod: 'range',
      isFetching: null
    }
  }), {})
}

export default function merchants(state = {}, action) {
  switch (action.type) {
    case MERCHANT.REQUEST:
    case MERCHANT_CREATE.REQUEST:
      return {
        ...state,
        isFetching: true
      }

    case MERCHANT.SUCCESS:
    case MERCHANT_CREATE.SUCCESS:
      return {
        ...state,
        isFetching: false,
        ...merchantReducer([].concat(action.response))
      }

    case MERCHANT.FAILURE:
    case MERCHANT_CREATE.FAILURE:
      return {
        ...state,
        isFetching: false
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/merchants/index.js